import YoutubePlayerWrapper from '../../../utils/youtube-video.js';
import YouTubeAnalytics from '../../../utils/analytics-helper.js';

export default class XLTileYoutubePlayer {
    constructor(el) {
        this.el = el;
        this.youTubeEle = el.querySelector('.xl-tile-lite-youtube-player');
        this.youTubeBtn = el.querySelector('.video-trigger');
        this.youTubeBtnMobile = el.querySelector('.video-trigger-mobile');
        this.closeBtn = el.querySelector('.youtube-close');
        this.selectors = {
            swiperContainer: '.xl-tile-light-swiper-container',
            swiperPagination: '.swiper-pagination',
            navigationNext: '.swiper-button-next',
            navigationPrev: '.swiper-button-prev',
        };
        this.classes = {
            videoPlaying: 'video-playing',
            videoPaused: 'video-paused',
            hidden: 'hidden',
            navHidden: 'nav-hidden',
        };
        this.analyticStates = {
            playing: 'Start',
            paused: 'Pause',
            ended: 'Complete',
        };
        this.player = null;
        this.init();
    }

    initYoutubePlayer() {
        const self = this;
        self.player = new YoutubePlayerWrapper(self.youTubeEle).getPlayerInstance();
    }

    sendAnalytics(playerState) {
        const self = this;
        let action = null;
        const { videoEventLabel } = self.youTubeEle.dataset;
        if (typeof videoEventLabel === 'string') {
            switch (playerState) {
            case 0:
                action = self.analyticStates.ended;
                break;
            case 1:
                action = self.analyticStates.playing;
                break;
            case 2:
                action = self.analyticStates.paused;
                break;
            }
            if (typeof action === 'string') {
                YouTubeAnalytics.push({
                    event: 'Video',
                    eventCategory: 'Video',
                    eventLabel: videoEventLabel,
                    eventAction: action,
                });
            }
        }
    }

    showPlayer() {
        const self = this;
        const element = document.getElementById(self.youTubeEle.getAttribute('id'));
        element.parentElement.classList.add(self.classes.videoPlaying);
        element.parentElement.classList.remove(self.classes.videoPaused);

        self.el.dispatchEvent(new CustomEvent('youtube-video-playing'));
        this.checkAuthPage();

        if (element.parentElement.classList.contains(self.classes.videoPlaying)) {
            if (element.parentElement.closest(self.selectors.swiperContainer)) {
                const pagEl = element.parentElement.closest(self.selectors.swiperContainer);
                pagEl.querySelector(self.selectors.swiperPagination).classList.add(self.classes.navHidden);
                pagEl.querySelector(self.selectors.navigationNext).classList.add(self.classes.navHidden);
                pagEl.querySelector(self.selectors.navigationPrev).classList.add(self.classes.navHidden);
            }
            self.player.playVideo();
        }

        self.player.addEventListener('onStateChange', (state) => {
            self.sendAnalytics(state.data);
            if (state.data === 0) {
                self.closeBtn.click();
                element.parentElement.classList.remove(self.classes.videoPlaying);
                element.parentElement.classList.add(self.classes.videoPaused);
                self.el.dispatchEvent(new CustomEvent('youtube-video-stop'));
            }
        });
    }

    hidePlayer() {
        const self = this;
        const element = document.getElementById(self.youTubeEle.getAttribute('id'));
        if (element.parentElement.classList.contains(self.classes.videoPlaying)) {
            if (element.parentElement.closest(self.selectors.swiperContainer)) {
                const pagEl = element.parentElement.closest(self.selectors.swiperContainer);
                pagEl.querySelector(self.selectors.swiperPagination).classList.remove(self.classes.navHidden);
                pagEl.querySelector(self.selectors.navigationNext).classList.remove(self.classes.navHidden);
                pagEl.querySelector(self.selectors.navigationPrev).classList.remove(self.classes.navHidden);
            }
            this.player.pauseVideo().then(() => {
                element.parentElement.classList.remove(self.classes.videoPlaying);
                element.parentElement.classList.add(self.classes.videoPaused);
            });
        }
        self.el.dispatchEvent(new CustomEvent('youtube-video-stop'));
    }

    checkAuthPage() {
        const self = this;
        const authContainer = self.el.closest('.aem-AuthorLayer-Preview');

        if (authContainer !== null) {
            authContainer.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
            });
        }
    }

    init() {
        const self = this;

        if (self.youTubeEle) {
            const playButtonHandler = function (event) {
                event.preventDefault();
                self.showPlayer();
            };

            const closeButtonHandler = function () { self.hidePlayer(); };

            self.youTubeBtn.addEventListener('click', playButtonHandler);
            self.youTubeBtnMobile.addEventListener('click', playButtonHandler);
            self.closeBtn.addEventListener('click', closeButtonHandler);

            self.initYoutubePlayer();
        }
    }
}
